const strings = {
  rank: "דרגה",
  personalParameters: "פרמטרים אישיים",
  calc: "חשב",
  isSpecialist: "האם מומחית",
  managers: "מנהלים",
  clear: "נקה טופס",
};
export default strings;
